import { Api } from '@/api/api';
import { Environment } from '@/models/environment';

export class EnvironmentApi extends Api {
    public async fetchAsync(): Promise<Environment> {
        return await this.getAsync<Environment>('v2/environment');
    }
}
